export default "__VITE_ASSET__WUqvQO54__"